module.exports = __webpack_public_path__ + "img/story005@2x.3bec58e3.png";